import axios from "../api/axios";
import store from "../store";

export default {
  async execute(method, resource, data) {
    return axios
      .smsEndPointNew({
        method,
        url: resource,
        data,
        headers: {
          customerId:
            store.getters.companyIdDropdown == null
              ? ""
              : store.getters.companyIdDropdown,
        },
      })
      .then((req) => {
        return req.data;
      });
  },
  async executeFiles(method, resource, data) {
    return axios
      .smsEndPointNew({
        method,
        url: resource,
        data,
        headers: {
          customerId:
            store.getters.companyIdDropdown == null
              ? ""
              : store.getters.companyIdDropdown,
        },
        responseType: "blob",
      })
      .then((req) => {
        return req.data;
      });
  },

  //Create New Planning Sheet related apis
  //Images List
  getItemsList(jobSite = "") {
    return this.execute("get", `Items?jobSite=${jobSite}`);
  },
  getApproversList() {
    return this.execute("get", `PlanningSheets/0/approvers`);
  },
  //get current approvers
  getcurrentApprovers(smsUserId, storeProjectionID, smsCustomerId) {
    console.log(smsUserId);
    console.log(smsCustomerId);
    return this.execute("get", `PlanningSheets/${storeProjectionID}/approvers`);
  },

  getavailableApprovers(smsUserId, storeProjectionID, smsCustomerId) {
    console.log(smsUserId);
    console.log(smsCustomerId);
    return this.execute("get", `PlanningSheets/${storeProjectionID}/approvers`);
  },
  // saving api's
  createNewPlanningSheet(smsUserId, payload) {
    console.log(smsUserId);
    return this.execute("post", `Planningsheets`, payload);
  },
  updatePlanningSheet(payload) {
    return this.execute("put", `Planningsheets`, payload);
  },
  copyProjectionSheet(planningSheetId, payload) {
    return this.execute(
      "post",
      `Planningsheets/${planningSheetId}/copy`,
      payload
    );
  },

  // Current sheet delete
  deleteCurrentSheetRecord(smsUserId, planningSheetId) {
    console.log(smsUserId);
    return this.execute("delete", `Planningsheets/${planningSheetId}`);
  },
  deleteReviewSheetRecord(planningSheetId, ItemId) {
    return this.execute(
      "delete",
      `/planningsheets/${planningSheetId}/items/${ItemId}`
    );
  },
  // submit purchase
  submitPurchase(payload) {
    return this.execute("post", `items/purchaserequest`, payload);
  },
  //lock projection/planning sheet
  lockPlanningsheet(planningSheetId) {
    return this.execute("put", `planningsheets/${planningSheetId}/lock`);
  },
  //notify  projection/planning sheet
  notifyPlanningsheet(planningSheetId) {
    return this.execute("put", `planningsheets/${planningSheetId}/notify`);
  },

  //Create New Planning Sheet && driopdowns data
  getContactsList(smsUserId, smsCustomerId, planningSheetId) {
    console.log(smsUserId);
    console.log(smsCustomerId);
    return this.execute("get", `PlanningSheets/${planningSheetId}/users`);
  },
  getPlanningSheetById(smsUserId, planningSheetId) {
    console.log(smsUserId);
    return this.execute("get", `PlanningSheets/${planningSheetId}`);
  },
  // Review Table & Card data
  getReviewActivityList(smsUserId, planningSheetId) {
    console.log(smsUserId);
    return this.execute("get", `PlanningSheets/${planningSheetId}`);
  },
  getReviewItemsList(smsUserId, planningSheetId) {
    console.log(smsUserId);
    return this.execute(
      "get",
      `PlanningSheets/ProjectionItems/${planningSheetId}`
    );
  },
  // Current Sheets List
  getCurrentActivityList(typeOfSheet) {
    return this.execute("get", `Planningsheets/${typeOfSheet}`);
  },
  //*History Report List
  getActivityList(typeOfSheet) {
    return this.execute("get", `Planningsheets/${typeOfSheet}`);
  },
  getJobsiteList(companyId) {
    let linkingID;
    if (companyId != null) {
      linkingID = companyId;
    } else {
      linkingID = 0;
    }
    console.log(linkingID);
    // return this.execute("get",`customer/%20%200000/jobsite`);
    return this.execute("get", `PlanningSheets/jobsite`);
  },
  getSuggestedItemsById(planningSheetId, itemId) {
    // console.log(smsUserId);
    return this.execute(
      "get",
      `PlanningSheets/${planningSheetId}/items/${itemId}`
    );
  },
  getSuggest(itemKey) {
    return this.execute("get", `/items/${itemKey}/suggesteditems`);
  },
  postReviewItemsList(planningSheetId, payload) {
    // console.log(smsUserId);
    return this.execute(
      "post",
      `Planningsheets/${planningSheetId}/items`,
      payload
    );
  },
  putReviewItemsList(planningSheetId, itemId, payload) {
    // console.log(smsUserId);
    return this.execute(
      "put",
      `Planningsheets/planningSheetItems/${planningSheetId}/items/${itemId}`,
      payload
    );
  },
  updateAdditionalNotes(payload) {
    return this.execute(
      "put",
      `Planningsheets/ProjectionItem/UpdateAdditionalNotes`,
      payload
    );
  },
  finalSubmitOfItems(planningSheetId) {
    return this.execute("put", `planningsheets/${planningSheetId}/submit`);
  },
  rejectItems(planningSheetId, payload) {
    return this.execute(
      "put",
      `planningsheets/${planningSheetId}/reject`,
      payload
    );
  },
  refreshRates(planningSheetId) {
    return this.execute(
      "put",
      `planningsheets/${planningSheetId}/refreshrates`
    );
  },
  updateCustomRates(itemId, payload) {
    return this.execute(
      "put",
      `PlanningSheets/ProjectionItem/${itemId}`,
      payload
    );
  },
  unlockPlanningsheet(planningSheetId) {
    return this.execute("put", `planningsheets/${planningSheetId}/unlock`);
  },
  // usermanagement smsid based customers jobsite

  getJobsiteListUserPage(smsCustomerId) {
    return this.execute(
      "get",
      `PlanningSheets/AvailableJobSiteRestrictions?customerId=${smsCustomerId}`
    );
  },
  getAvailableJobNoRestrictions(smsCustomerId) {
    return this.execute(
      "get",
      `PlanningSheets/availablejobnorestrictions?customerId=${smsCustomerId}`
    );
  },
  getAvailableOrderedByRestrictions(smsCustomerId) {
    return this.execute(
      "get",
      `PlanningSheets/availableOrderedbyrestrictions?customerId=${smsCustomerId}`
    );
  },
  getAvailablePONoRestrictions(smsCustomerId) {
    return this.execute(
      "get",
      `PlanningSheets/availableponorestrictions?customerId=${smsCustomerId}`
    );
  },
  getAvailablePickedUpByRestrictions(smsCustomerId) {
    return this.execute(
      "get",
      `PlanningSheets/availablepickedupbyrestrictions?customerId=${smsCustomerId}`
    );
  },
  // SMS Reports
  getActualCostReport(
    fromDate,
    EndDate,
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));
    if (
      fromDate == null ||
      fromDate == undefined ||
      fromDate == "" ||
      EndDate == null ||
      EndDate == undefined ||
      EndDate == ""
    ) {
      fromDate = "";
      EndDate = "";
    }
    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.execute(
      "GET",
      `Reports/actualcost?startDate=${fromDate}&endDate=${EndDate}&itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&poNo=${searchPO}&jobNo=${searchJob}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}`
    );
  },
  exportActualCostReport(
    reportType,
    fromDate,
    EndDate,
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));
    if (
      fromDate == null ||
      fromDate == undefined ||
      fromDate == "" ||
      EndDate == null ||
      EndDate == undefined ||
      EndDate == ""
    ) {
      fromDate = "";
      EndDate = "";
    }
    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.executeFiles(
      "GET",
      `Reports/actualcost/${reportType}?startDate=${fromDate}&endDate=${EndDate}&itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&poNo=${searchPO}&jobNo=${searchJob}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}`
    );
  },
  getOffRentReport(
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }

    return this.execute(
      "GET",
      `Reports/offrent?itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&poNo=${searchPO}&jobNo=${searchJob}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}      `
    );
  },
  exportOffRentReport(
    reportType,
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }

    return this.executeFiles(
      "GET",
      `Reports/offrent/${reportType}?itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&poNo=${searchPO}&jobNo=${searchJob}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model} `
    );
  },
  getOnRentWithCostAnalysisReport(
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));
    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.execute(
      "GET",
      `Reports/costanalysis?itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&poNo=${searchPO}&jobNo=${searchJob}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}`
    );
  },
  exportOnRentWithCostAnalysisReport(
    reportType,
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }

    return this.executeFiles(
      "GET",
      `Reports/costanalysis/${reportType}?itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&poNo=${searchPO}&jobNo=${searchJob}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}`
    );
  },
  getRentToDateReport(
    fromDate,
    EndDate,
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (
      fromDate == null ||
      fromDate == undefined ||
      fromDate == "" ||
      EndDate == null ||
      EndDate == undefined ||
      EndDate == ""
    ) {
      fromDate = "";
      EndDate = "";
    }
    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.execute(
      "get",
      `Reports/renttodateprojected?startDate=${fromDate}&endDate=${EndDate}&itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&poNo=${searchPO}&jobNo=${searchJob}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}`
    );
  },

  getActiveMaintenanceReport(
    fromDate,
    EndDate,
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (
      fromDate == null ||
      fromDate == undefined ||
      fromDate == "" ||
      EndDate == null ||
      EndDate == undefined ||
      EndDate == ""
    ) {
      fromDate = "";
      EndDate = "";
    }
    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.execute(
      "get",
      `Reports/activemaintenancerequests?startDate=${fromDate}&endDate=${EndDate}&itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}`
    );
  },
  exportActiveMaintenance(
    reportType,
    fromDate,
    EndDate,
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (
      fromDate == null ||
      fromDate == undefined ||
      fromDate == "" ||
      EndDate == null ||
      EndDate == undefined ||
      EndDate == ""
    ) {
      fromDate = "";
      EndDate = "";
    }
    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.executeFiles(
      "get",
      `Reports/activemaintenancerequests/${reportType}?startDate=${fromDate}&endDate=${EndDate}&itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}`
    );
  },
  getHistoricalMaintenanceReport(
    fromDate,
    EndDate,
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (
      fromDate == null ||
      fromDate == undefined ||
      fromDate == "" ||
      EndDate == null ||
      EndDate == undefined ||
      EndDate == ""
    ) {
      fromDate = "";
      EndDate = "";
    }
    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.execute(
      "get",
      `Reports/MaintenanceHistory?startDate=${fromDate}&endDate=${EndDate}&itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}`
    );
  },
  exportHistoricalMaintenance(
    reportType,
    fromDate,
    EndDate,
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (
      fromDate == null ||
      fromDate == undefined ||
      fromDate == "" ||
      EndDate == null ||
      EndDate == undefined ||
      EndDate == ""
    ) {
      fromDate = "";
      EndDate = "";
    }
    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.executeFiles(
      "get",
      `Reports/MaintenanceHistory/${reportType}?startDate=${fromDate}&endDate=${EndDate}&itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}`
    );
  },

  exportRentToDateExcel(
    exportType,
    fromDate,
    EndDate,
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (
      fromDate == null ||
      fromDate == undefined ||
      fromDate == "" ||
      EndDate == null ||
      EndDate == undefined ||
      EndDate == ""
    ) {
      fromDate = "";
      EndDate = "";
    }
    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.executeFiles(
      "get",
      `Reports/renttodateprojected/${exportType}?startDate=${fromDate}&endDate=${EndDate}&itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&poNo=${searchPO}&jobNo=${searchJob}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}`
    );
  },
  getCustomerBalanceReport(jobSites, searchPO, searchJob, searchContractId) {
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.execute(
      "get",
      `Reports/customerbalance?jobsite=${jobsiteNames}&contractId=${searchContractId}&poNo=${searchPO}&jobNo=${searchJob}`
    );
  },
  exportCustomerBalanceReport(
    reportType,
    jobSites,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.executeFiles(
      "get",
      `Reports/customerbalance/${reportType}?jobsite=${jobsiteNames}&contractId=${searchContractId}&poNo=${searchPO}&jobNo=${searchJob}`
    );
  },
  getServiceCallReport(
    fromDate,
    EndDate,
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (
      fromDate == null ||
      fromDate == undefined ||
      fromDate == "" ||
      EndDate == null ||
      EndDate == undefined ||
      EndDate == ""
    ) {
      fromDate = "";
      EndDate = "";
    }
    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.execute(
      "get",
      `Reports/servicecall?startDate=${fromDate}&endDate=${EndDate}&itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&poNo=${searchPO}&jobNo=${searchJob}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}`
    );
  },
  exportServiceCall(
    reportType,
    fromDate,
    EndDate,
    machines,
    zones,
    groups,
    jobSites,
    models,
    searchEquipName,
    searchPO,
    searchJob,
    searchContractId
  ) {
    let machineIds = encodeURIComponent(machines.join(","));
    let zoneIds = zones.join(",");
    let groupIds = groups.join(",");
    let model = models.join(",");
    let jobsiteNames = encodeURIComponent(jobSites.join(";"));

    if (
      fromDate == null ||
      fromDate == undefined ||
      fromDate == "" ||
      EndDate == null ||
      EndDate == undefined ||
      EndDate == ""
    ) {
      fromDate = "";
      EndDate = "";
    }
    if (searchEquipName == null || searchEquipName == undefined) {
      searchEquipName = "";
    }
    if (searchPO == null || searchPO == undefined) {
      searchPO = "";
    }
    if (searchJob == null || searchJob == undefined) {
      searchJob = "";
    }
    if (searchContractId == null || searchContractId == undefined) {
      searchContractId = "";
    }
    return this.executeFiles(
      "get",
      `Reports/servicecall/${reportType}?startDate=${fromDate}&endDate=${EndDate}&itemKeys=${machineIds}&jobsite=${jobsiteNames}&contractId=${searchContractId}&equipmentName=${searchEquipName}&poNo=${searchPO}&jobNo=${searchJob}&groupIds=${groupIds}&geofenceIds=${zoneIds}&model=${model}`
    );
  },
  getItemsRentedReport(fromDate, EndDate, jobsites) {
    if (
      fromDate == null ||
      fromDate == undefined ||
      fromDate == "" ||
      EndDate == null ||
      EndDate == undefined ||
      EndDate == ""
    ) {
      fromDate = "";
      EndDate = "";
    }
    return this.execute(
      "get",
      `Reports/itemsrented?startDate=${fromDate}&endDate=${EndDate}&jobsite=${jobsites}`
    );
  },
  exportGetItemsRentedReport(reportType, fromDate, EndDate, jobsites) {
    if (
      fromDate == null ||
      fromDate == undefined ||
      fromDate == "" ||
      EndDate == null ||
      EndDate == undefined ||
      EndDate == ""
    ) {
      fromDate = "";
      EndDate = "";
    }
    return this.executeFiles(
      "get",
      `Reports/itemsrented/${reportType}?startDate=${fromDate}&endDate=${EndDate}&jobsite=${jobsites}`
    );
  },
  sendOnRentEmailToBirch(payload) {
    return this.execute("Post", `Reports/sendactionsemail`, payload);
  },
  getPlannedVsActualReport(planningSheetId, isExtended) {
    // let customerId = "6";
    // https://api.birchequipment.com/customeruser/159/plannedvsactual?projectionid=1182&customerID=6
    return this.execute(
      "get",
      `/Reports/plannedvsactual_new?projectionId=${planningSheetId}&IsExtended=${isExtended}`
    );
  },
  exportPlannedVsActualReport(reportType, planningSheetId, isExtended) {
    return this.executeFiles(
      "get",
      `Reports/plannedvsactual_new/${reportType}?projectionId=${planningSheetId}&IsExtended=${isExtended}`
    );
  },
  getPlannedVsActualReportDropdown() {
    return this.execute("get", `/PlanningSheets/ProjectionLocked`);
  },
  updateItemOrder(payload) {
    return this.execute("put", `/Items/itemorder`, payload);
  },
  getAllPlanningSheetExceptions() {
    return this.execute("get", `/PlanningSheets/exceptions`);
  },
  getPlanningSheetExceptionsById(pid) {
    return this.execute("get", `/PlanningSheets/exceptions/${pid}`);
  },
  createPlanningSheetExceptionsById(pid, payload) {
    return this.execute("post", `/PlanningSheets/exceptions/${pid}`, payload);
  },
  updatePlanningSheetExceptionsById(pid, payload) {
    return this.execute("put", `/PlanningSheets/exceptions/${pid}`, payload);
  },
  removePlanningSheetExceptionsById(pid) {
    return this.execute("delete", `/PlanningSheets/exceptions/${pid}`);
  },
};
